import Axios from 'axios';
import client from './client';
import WebAPI from './api-calls';
import { getAccessToken } from './localstorage';
import { rateHandler } from './rate-handler';

const uploadClient = Axios.create();

const withAccessToken = (request) => {
    const task = async (res, rej) => {
        const bearerToken = getAccessToken();
        if (!bearerToken) {
            const error = { success: false, message: 'no_access_token' };
            return rej(error);
        }

        await request({ headers: { Authorization: bearerToken, 'Content-Type': 'application/json' } })
            .then((resp) => res({ success: true, data: resp.data }))
            .catch((err) => rej(err));
    };
    return rateHandler(task);
};

export const getPortalDocumentUploadFeatureFlag = () => {
    const task = async (res, rej) => {
        const webApi = new WebAPI();
        await webApi.getFromWebApiWithAccessTokenAsync('/api/multiutility/portal-document-upload-feature-flag')
            .then((resp) => res(resp))
            .catch((err) => {
                if (err && err.response && err.response.status === 429) return rej(err);
                res({ success: true });
            });
    };
    return rateHandler(task);
};

export const createDocument = ({ fileName, sizeBytes, contentType, submissionReference }) =>
    withAccessToken((config) =>
        client.post('/api/multiutility/documents', { fileName, sizeBytes, contentType, submissionReference }, config)
    );

export const confirmDocumentUpload = (documentDomainId) =>
    withAccessToken((config) => client.post(`/api/multiutility/documents/${documentDomainId}/uploaded`, {}, config));

export const getDocumentStatus = (documentDomainId) =>
    withAccessToken((config) => client.get(`/api/multiutility/documents/${documentDomainId}`, config));

export const getDocumentStatusConfig = () =>
    withAccessToken((config) => client.get('/api/multiutility/document-status-config', config));

export const removeDocument = (documentDomainId) =>
    withAccessToken((config) => client.delete(`/api/multiutility/documents/${documentDomainId}`, config));

export const uploadToLink = (uploadUrl, file, onProgress) =>
    uploadClient.put(uploadUrl, file, {
        headers: {
            'x-ms-blob-type': 'BlockBlob',
            'Content-Type': file.type || 'application/octet-stream',
        },
        onUploadProgress: (event) => {
            if (onProgress && event.total) onProgress(Math.round((event.loaded / event.total) * 100));
        },
    });
